import SafetyDatabaseObservationTypes from './safetyDatabaseObservation.types';

export const hydrateObservationForm = ({ submission }) => ({
	type: SafetyDatabaseObservationTypes.DB_HYDRATE_OBSERVATION_FORM,
	payload: { submission }
});

export const updateActivity = (key, value) => ({
	type: SafetyDatabaseObservationTypes.DB_UPDATE_ACTIVITY,
	payload: { key, value }
});

export const updateTypeOfObservation = (key, value) => ({
	type: SafetyDatabaseObservationTypes.DB_UPDATE_TYPE_OF_OBSERVATION,
	payload: { key, value }
});

export const updateCondition = ({ section, condition, safe, concern }) => ({
	type: SafetyDatabaseObservationTypes.DB_UPDATE_CONDITION,
	payload: { section, condition, safe, concern }
});

export const updateTextField = ({ key, value }) => ({
	type: SafetyDatabaseObservationTypes.DB_UPDATE_TEXT_FIELD,
	payload: { key, value }
});

export const updateHazardStatus = ({ completed, pending }) => ({
	type: SafetyDatabaseObservationTypes.DB_UPDATE_HAZARD_STATUS,
	payload: { completed, pending }
});

export const updateNearMisses = ({ key, value }) => ({
	type: SafetyDatabaseObservationTypes.DB_UPDATE_NEAR_MISSES,
	payload: { key, value }
});

export const updateDate = ({ manual, date }) => ({
	type: SafetyDatabaseObservationTypes.DB_UPDATE_DATE,
	payload: { manual, date }
});
